import { Box } from '@fhs-legacy/universal-components';

export const LoyaltyLoaderContainer = Box.withConfig({
  height: '100%',
  position: 'absolute',
  alignSelf: 'center',
  justifyContent: 'center',
});
